import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, Injectable, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MaterializeModule } from 'angular2-materialize';
import { LaddaModule } from 'angular2-ladda';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { ZestCommonModule } from './common/common.module';

import { AppRoutingModule } from './app-routing.module';
import { ApplicationModule } from './application/application.module';
import { DashboardModule } from './dashboard/dashboard.module';

import { AppComponent } from './app.component';

import { ProgressTrackerComponent } from './common/progress-tracker/progress-tracker.component';
import { LoginComponent } from './login/login.component';
import { SelectEmiComponent } from './application/select-emi/select-emi.component';
import { ErrorComponent } from './info-pages/error/error.component';
import { RedirectComponent } from './redirect/redirect.component';

import { TokenService } from './token/token.service';
import { ShieldService } from './risk/shield.service';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { BackendService } from './backend.service';
import { LoginService } from './login/login.service';
import { HeaderComponent } from './common/header/header.component';
import { FooterComponent } from './common/footer/footer.component';
import { LoaderComponent } from './common/loader/loader.component';
import { ApplicationService } from './application/application.service';
import { EmailMobileService } from './customer/email-mobile/email-mobile.service';
import { HeaderService } from './common/header/header.service';
import { FooterService } from './common/footer/footer.service';
import { LoaderService } from './common/loader/loader.service';
import { ProgressTrackerService } from './common/progress-tracker/progress-tracker.service';
import { AadhaarService } from './aadhaar/aadhaar.service';
import { RiskService } from './risk/risk.service';
import { DownpaymentService } from './application/down-payment/down-payment.service';
import { PersonalDetailsService } from './customer/personal-details/personal-details.service';
import { DocumentsService } from './customer/documents/documents.service';
import { StatementsService } from './customer/statements/statements.service';
import { AuthGuardService } from './auth-guard.service';
import { LoginGuardService } from './login-guard.service';
import { AwsTrackingService } from './common/tracking/aws-tracking.service';
import { ChatService } from './common/chat/chat.service';
import { EmiResolveService } from './application/select-emi/emi-resolve.service';
import { ApplicationResolveService } from './application/application-resolve.service';
import { NachService } from './repayments/nach/nach.service';
import { AuthenticationService } from './authentication/authentication/authentication.service';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import * as Sentry from '@sentry/browser';
import { LoansModule } from './loans/loans.module';
import { RedirectResolveService } from './redirect-resolve.service';


Sentry.init({
  dsn: 'https://1a727f1d11f2487d9d07400089e33548@sentry.zestmoney.in/2',
  environment: environment.type,
});
@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor() { }
  handleError(error) {
    Sentry.captureException(error.originalError || error);
    console.error(error);
    // Sentry.showReportDialog({ eventId });
  }
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SelectEmiComponent,
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    ProgressTrackerComponent,
    ErrorComponent,
    RedirectComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    MaterializeModule,
    AppRoutingModule,
    NgxWebstorageModule.forRoot(),
    DeviceDetectorModule.forRoot(),
    LaddaModule.forRoot({
      style: 'contract',
      spinnerSize: 50,
      spinnerColor: '#1eba68',
      spinnerLines: 100,
    }),
    DashboardModule,
    ZestCommonModule,
    ApplicationModule,
    LoansModule,
    BrowserAnimationsModule
  ],
  providers: [
    RedirectResolveService,
    AwsTrackingService,
    ChatService,
    AuthGuardService,
    LoginGuardService,
    RiskService,
    TokenService,
    BackendService,
    ProgressTrackerService,
    PersonalDetailsService,
    LoginService,
    ApplicationService,
    HeaderService,
    FooterService,
    LoaderService,
    ProgressTrackerService,
    AadhaarService,
    StatementsService,
    DownpaymentService,
    DocumentsService,
    EmailMobileService,
    EmiResolveService,
    ApplicationResolveService,
    AuthenticationService,
    NachService,
    ShieldService,
    { provide: ErrorHandler, useClass: SentryErrorHandler }
  ],
  bootstrap: [
    AppComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule { }
